/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import * as API from '../../framework/API/api'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ENTITYNAME, PUBLISHING_SOURCE, MEDIACATEGORIES, OTTROUTETYPE, ASSETTYPE, MODULE, LOGEVENT, LOCALSTORAGE_KEY, ACCESS_LEVEL, BA_ACTION, MEDIA_TRANSMISSION, TOAST_TYPES } from "../../framework/constant/constant";
import { CardList } from "../../components/CardList";
import { FixedSidebarWithIcons } from "../../components/FixedSidebarWithIcons";
import SeriesDetailForm from "./SeriesDetailForm";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import SeasonMetaDataEditForm from "./SeasonMetaDataEditForm";
import { EditPageHeader } from "../../components/EditPageHeader";
import MediaEpisodePublishingEditForm from "./MediaEpisodePublishingEditForm";
import { useTranslation } from "../../locale/useTranslation";
import MediaEpisodeAssetEditForm from "./MediaEpisodeAssetEditForm";
import moment from "moment";
import { ConfirmAlert } from "../../ConfirmAlert";
import { DataHelper } from "../../framework/helper/DataHelper";
import { utility } from "../../framework/utility/utilityProvider";
import BossAssistantIcon from "./component/BossAssistantIcon";
import { TransmissionBrowser } from "./NodeTreeView/TransmissionBrowser";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import ToastNotification from "../../components/ToastNotification";

export const SeriesEditForm = (props) => {

  const location = useLocation();
  const navigate = useNavigate();
  const lang = useTranslation();
  const { SID } = useParams();
  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

  let blankDataItem = {
    SID: SID,
    Title: '',
    Content: {},
    Description: '',
    ImageUrl: '',
    Synopsis: '',
    Archive: false,
    Posters: [],
    Languages: [],
    Keywords: '',
    PGRating: {},
    ImageUrl: 'https://i.postimg.cc/j5PsF5jZ/defaultmovie.png',
    SeasonNumber: 1,
    IsLive: false,
    Genre: [],
    SubGenre: [],
    Transmission: { _id: MEDIA_TRANSMISSION.READY, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, MEDIA_TRANSMISSION.READY) },
    Categories: [],
    Provider: {},
    Extension: {},
    dynamicField: {},
    DubbedLanguages: [],
    Channels: [],
    Platforms: [],
    isLinearUnlimitedRights: true,
    LinearStartDate: null,
    LinearEndDate: null,
    isNonLinearUnlimitedRights: true,
    NonLinearStartDate: null,
    NonLinearEndDate: null,
  }

  const [seriesEntity, setSeriesEntity] = useState(
    location.state && location.state.isFromAddProgram && location.state.dataItem ?
      { ...blankDataItem, ...location.state.dataItem } : blankDataItem);

  const [season, setSeason] = useState([]);
  const [tabNumber, setTabNumber] = React.useState("1");

  const isAssestID = utility.isNumeric(SID) == false;
  const isEdit = isAssestID || SID > 0 ? true : false;
  const [openSeason, setOpenSeason] = useState(isEdit);
  const [isLoadedEdit, setIsLoadedEdit] = useState(false);
  const [mediaEpisodeEntity, setMediaEpisodeEntity] = useState({});

  const [mediaCategory, setMediaCategory] = useState([]);
  const [assetDataItem, setAssetDataItem] = useState({});
  const [showSeasonCollection, setShowSeasonCollection] = useState(false);

  const [createSeasonEpisode, setCreateSeasonEpisode] = useState(
    location.state && location.state.isFromAddProgram && location.state.createSeasonEpisode ?
      location.state.createSeasonEpisode : []
  );

  const [isArchiveChanged, setIsArchiveChanged] = useState(false);
  const [imagePotraitImageFiles, setPotraitImageFiles] = useState(new Set());
  const [imageLandscapeImageFiles, setLandscapeImageFiles] = useState(new Set());

  const [openPublishingDialog, setOpenPublishingDialog] = useState(false);

  const [genres, setGenres] = useState([]);
  const [pgRatings, setPGRatings] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [isManualAssetId, setIsManualAssetId] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const customeModelFields = {
    Title: "Title",
    Description: "Description",
    PosterURL: "ImageUrl",
    ThirdLine: "SeasonNumber"
  }

  useEffect(() => {
    loadcombo();
    if (isEdit) {
      loadEditData();
    } else {
      //in new it should be loaded without server fretching data
      setIsLoadedEdit(true);
    }
  }, [SID])

  const loadcombo = async () => {
    let mediaCategory = await API.getDataLookup(ENTITYNAME.MediaCategory);
    setMediaCategory(mediaCategory.data);
    let genreRes = await API.getDataLookup(ENTITYNAME.Genre);
    setGenres(genreRes.data);
    let pgRatingRes = await API.getDataLookup(ENTITYNAME.PGRating);
    setPGRatings(pgRatingRes.data);
    let languageRes = await API.getDataLookup(ENTITYNAME.Language);
    setLanguages(languageRes.data);
  }

  const handleTabChange = (event, newValue) => {
    setTabNumber(`${newValue}`);
  };

  const loadEditData = async () => {

    let res = { message: "Not Valid", success: false };

    if (isAssestID) {
      res = await API.getEntityfromAssestID(ENTITYNAME.Series, SID);
    }
    else {
      res = await API.getEntity(ENTITYNAME.Series, SID);
    }

    if (!res.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      return;
    }

    let season = await API.getData(ENTITYNAME.Season, { query: ["Series_Id", "=", res.data._id], sort: { SeasonNumber: 1 } });
    console.log(season.data)

    if (season.success) {
      let seasonData = [...season.data].map((item) => { return { ...item, SeasonNumber: "Season: " + item.SeasonNumber } });
      setSeason(seasonData);
    }

    setSeriesEntity({
      ...blankDataItem, ...res.data,
      Transmission: res?.data?.Transmission ? { _id: res?.data?.Transmission, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, res?.data?.Transmission) } : { _id: MEDIA_TRANSMISSION.READY, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, MEDIA_TRANSMISSION.READY) },
      Provider: typeof res?.data?.Provider === 'string' ? { Description: res?.data?.Provider } : res?.data?.Provider?._id ? res?.data?.Provider : {}
    });
    setIsLoadedEdit(true);
    setMediaEpisodeEntity(res.data);

    //load asset details
    if (res.data.IsOttAsset) {

      let assetRes = await API.getData(ENTITYNAME.OttAsset, { query: [['Source._id', '=', res.data._id], ['Source.entityName', '=', 'series']] });
      console.log(assetRes);
      if (assetRes.data && assetRes.data.length > 0) {
        [
          setAssetDataItem({ ...assetRes.data[0], IsOttAsset: res.data.IsOttAsset })
        ]
      }
    }

  };

  const setMataData = (data) => {
    setSeriesEntity({ ...seriesEntity, ...data });
  }

  const createNewSeasonEpisode = async (seriesId, data) => {

    if (data.SID == 0 && createSeasonEpisode.length > 0) {
      let seasonData = {
        seriesId: seriesId,
        seasons: createSeasonEpisode,
        customTitle: seriesEntity.CustomTitle
      }

      console.log("seasonData");
      console.log(seasonData);

      //Creating Seasons and Episodes
      let response = await API.createSeriesSeasons(seasonData);

      console.log(response);

      if (!response.success) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
        return null;
      } else {

        //MAINTAING LOGS FOR NEW CREATED SEASON AND EPISODES from SERIES
        if (response?.success && response?.data?.MediaEpisode.length > 0) {
          response?.data?.MediaEpisode.forEach((obj) => {
            obj?.data.forEach((x) => {
              let logData = { event: LOGEVENT.CREATE_EPISODE, module: MODULE.EPISODE, data: x?.data, message: 'Create Episode' };
              API.SaveLogs(logData);
            })
          });
        }

        if (response?.success && response?.data?.Season?.length > 0) {
          response?.data?.Season?.forEach((obj) => {
            let logData = { event: LOGEVENT.CREATE_SERIES, module: MODULE.MEDIA_EPISODE_SEASON, data: obj?.data, message: 'Create Media Episode Series' };
            API.SaveLogs(logData);
          });
        }
        return response;
      }
    }
    return null;

  }

  const saveArchiveChange = async () => {
    if (isArchiveChanged && seriesEntity.SID > 0) {
      console.log('------here------')
      await API.onChangeArchiveInSeriesSeason({
        _id: seriesEntity._id,
        archive: seriesEntity.Archive,
        entityName: ENTITYNAME.Series
      })
      setIsArchiveChanged(false);
    }
  }

  const onSave = async () => {
    setIsSaving(true);
    try {

      let localSeriesEntity = { ...seriesEntity };

      const series_id = localSeriesEntity._id;

      let data = DataHelper.saveSeriesEntity({ ...localSeriesEntity, SID: parseInt(localSeriesEntity.SID) }, mediaCategory, assetDataItem.IsOttAsset, localSeriesEntity?.ImageUrl);

      if (data?._id?.toString()?.length > 0) {
        delete data?._id
      }

      if (assetDataItem.IsOttAsset && !isValidAsset()) {
        return;
      }

      if (data.SID == 0 && !isManualAssetId) {
        data.AssetId = await DataHelper.getNewAssetId(localSeriesEntity.Content, true);
      }

      let res = await API.saveData(ENTITYNAME.Series, data);

      if (!res.success) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      } else {

        //CREATE NEW SEASON AND EPISODES
        let newSeasonEpisodeRes = await createNewSeasonEpisode(res.data._id, data);
        if (newSeasonEpisodeRes) handleSetSeriesEntity(res.data, newSeasonEpisodeRes?.data?.Season);

        // Update season episode count
        await API.updateSeasonEpisodeCount({
          data: res.data, //series saved entity
          entityName: ENTITYNAME.Series
        });

        //ARCHIVE DATA FOR WHOLE SERIES 
        await saveArchiveChange();

        let resMediaDealRights = {};
        // New saving of deal rights
        if (SID == 0) {
          let transmissionTypes = await API.getDataLookup(ENTITYNAME.TransmissionTypes);
          let defaultDealRightsData = DataHelper.getDefaultDealRights({ transmissionType: transmissionTypes?.data?.find(x => x?.Name?.toLowerCase() === "svod"), isLinearUnlimitedRights: localSeriesEntity?.isLinearUnlimitedRights, linearStartDate: localSeriesEntity?.LinearStartDate, linearEndDate: localSeriesEntity?.LinearEndDate, isNonLinearUnlimitedRights: localSeriesEntity?.isNonLinearUnlimitedRights, nonLinearStartDate: localSeriesEntity?.NonLinearStartDate, nonLinearEndDate: localSeriesEntity?.NonLinearEndDate, channels: localSeriesEntity?.Channels, platforms: localSeriesEntity?.Platforms, publishingSource: PUBLISHING_SOURCE.Series })
          resMediaDealRights = await API.createAndUpdateDealRights(defaultDealRightsData, res.data._id);
        }

        //OTT ASSET TAB SAVE
        let assetsData = {};
        if (assetDataItem.IsOttAsset) {
          let assetRes = await onAssetSubmit({ ...res.data, _id: series_id });
          if (assetRes.success) {
            assetsData = assetRes.data
          }
        }

        let logData = {
          event: localSeriesEntity.SID == 0 ? LOGEVENT.CREATE_PARENT_SERIES : LOGEVENT.UPDATE_PARENT_SERIES, module: MODULE.MEDIA_EPISODE_SERIES,
          data: { ...res.data, MediaDealRights: resMediaDealRights?.data, _id: series_id, Assets: assetsData },
          message: res.message
        };
        API.SaveLogs(logData);
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Saved Successfully" });

        if (props.quickEdit) {
          navigate(location.state.prevPath);
        } else {
          let findIndex = location?.state?.prevPath.indexOf("?");
          let pagination = location?.state?.prevPath?.slice(findIndex, location?.state?.prevPath?.length) ?? "";
          let state = {
            quickEdit: false,
            prevPath: location?.state?.prevPath ?? "/home/MediaEpisode/Series",
            pagination: location?.state.pagination ?? pagination,
            paths: location.state.paths
          }
          navigate(`/home/MediaEpisode/Series/${res.data.SID}`, { state: state });
        }

        setOpenSeason(true);
      }
    } catch (error) {
      console.error(error);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error.message });
    } finally {
      setIsSaving(false);
    }
  }


  const handleSetSeriesEntity = (data, seasonData) => {

    setSeriesEntity(data);

    let tempSeasonData = [];
    if (seasonData.length > 0) {
      seasonData.map((obj) => {
        tempSeasonData.push(obj.data);
      })
      setSeason(tempSeasonData);
    }

  }

  const deleteSeason = async (index, dataItem) => {
    console.log(dataItem);

    setSeason((old) => old.filter((obj) => obj.SID != dataItem.SID));
    let res = await API.saveData(ENTITYNAME.Season, {
      ...dataItem,
      Series_Id: ''
    });
    if (!res.success) return;

  }

  const onSeasonEdit = (index, dataItem) => {
    console.log(dataItem);
    let findIndex = location?.state?.prevPath.indexOf("?");
    let state = {
      quickEdit: false,
      prevPath: location.pathname,
      pagination: location?.state?.prevPath?.slice(findIndex, location?.state?.prevPath?.length) ?? "",
      paths: [...location.state.paths, location.pathname]
    }
    navigate(`/home/MediaEpisode/Season/${dataItem.SID}`, { state: state });
  }

  const getSeriesMenu = (index, dataItem) => {
    return [
      {
        label: `${lang.options_actionbutton_menutext}`,
        items: [
          { label: `${lang.delete_actionbutton_option}`, icon: 'pi pi-fw pi-trash', command: () => { } },
          { label: `${lang.moveup_actionbutton_option}`, icon: 'pi pi-fw pi-arrow-up ', command: () => { } },
          { label: `${lang.movedown_actionbutton_option}`, icon: 'pi pi-fw pi-arrow-down', command: () => { } }
        ]
      }
    ]
  }

  const sideFixMenu = [
    {
      icon: 'play',
      title: `${lang.sidefix_season_tooltip}`,
      onClick: () => { setOpenSeason(old => !old) }
    },
  ]

  //asset
  const setAssetEntity = (entity) => {
    setAssetDataItem(entity)
  }

  function isValidAsset() {

    let routeTypeID = typeof assetDataItem.routeType === 'object' ? assetDataItem.routeType.ID : assetDataItem.routeType;

    if (!assetDataItem.VodTypes || Object.keys(assetDataItem.VodTypes).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_vod_type_validation_error_message });
      return false;
    }

    if (!routeTypeID || routeTypeID === "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_route_type_error_message });
      return false;
    }

    if ((assetDataItem.routeType == (OTTROUTETYPE.Page || OTTROUTETYPE.PiPage) || assetDataItem.routeType.ID == (OTTROUTETYPE.Page || OTTROUTETYPE.PiPage)) && (assetDataItem.page_id == "" || assetDataItem.page_id == undefined)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_page });
      return false;
    }

    if ((assetDataItem.routeType == OTTROUTETYPE.Player || assetDataItem.routeType.ID == OTTROUTETYPE.Player)
      && assetDataItem.Videos.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_atleast_one_video_error_message });
      return false;
    }

    let videosArr = utility.getItemDisplayValueByLang(assetDataItem.Videos, company.Language)
    if (routeTypeID == OTTROUTETYPE.Deeplink && !videosArr.some(x => x.OttVideoType?.Description === "Deeplink")) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_add_deeplink_in_video_list_error_message });
      return false;
    }

    if (assetDataItem.Videos.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_atleast_one_video_error_message });
      return false;
    }

    if (assetDataItem.Posters.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_atleast_one_poster_error_message });
      return false;
    }

    return true;
  }

  const onAssetSubmit = async (seriesEntity) => {

    //MUTILANG TITLE & DESCRIPTION
    let title = assetDataItem.Title && assetDataItem.Title.length > 0 ? assetDataItem.Title : [
      {
        langISO: company.Language.ISOCode,
        value: mediaEpisodeEntity.Title
      }
    ];
    let description = assetDataItem.Description && assetDataItem.Description.length > 0 ? assetDataItem.Description : [
      {
        langISO: company.Language.ISOCode,
        value: assetDataItem.Description
      }
    ];

    const saveData = {
      Title: title,
      Description: description,
      TBA: assetDataItem.TBA ?? false,
      StartDate: assetDataItem.StartDate ? new Date(assetDataItem.StartDate).getTime() : new Date(moment(new Date()).format('YYYY-MM-DD')).getTime(),
      EndDate: assetDataItem.EndDate ? new Date(assetDataItem.EndDate).getTime() : new Date(moment(new Date()).add(1, 'M').format('YYYY-MM-DD')).getTime(),
      OttAssetTypeSID: ASSETTYPE['Media Asset'],
      Archive: assetDataItem.Archive ?? false,
      Source: { _id: seriesEntity._id, SID: seriesEntity.SID, Title: seriesEntity.Title, MediaCategory: seriesEntity.MediaCategory, entityName: 'series' },
      routeType: typeof assetDataItem.routeType === 'object' ? assetDataItem.routeType.ID : assetDataItem.routeType,
      page_id: typeof assetDataItem.page_id === 'object' ? assetDataItem.page_id._id : assetDataItem.page_id,
      VodTypes: {
        _id: assetDataItem.VodTypes._id,
        SID: assetDataItem.VodTypes.SID,
        Name: assetDataItem.VodTypes.Name
      },
      Provider: assetDataItem?.Provider?._id ? assetDataItem?.Provider?._id : "",
      Videos: assetDataItem.Videos ?? [],
      Posters: assetDataItem.Posters ?? [],
      RentalRetailPrice: assetDataItem.VodTypes.Name == 'TVOD' ? parseFloat(assetDataItem.RentalRetailPrice) : 0,
      RentalWholesalePrice: assetDataItem.VodTypes.Name == 'TVOD' ? parseFloat(assetDataItem.RentalWholesalePrice) : 0,
      WebAssets: assetDataItem?.WebAssets ? assetDataItem?.WebAssets?._id : "",
      accessLevel: assetDataItem?.accessLevel?._id ?? ACCESS_LEVEL.Both,
      SubTitles: assetDataItem?.SubTitles && assetDataItem?.SubTitles.length > 0 ? assetDataItem?.SubTitles : [],
      thumbnailUrl: assetDataItem?.thumbnailUrl ?? "",
      Segments: (assetDataItem?.Segments && assetDataItem?.Segments?.length > 0) ? assetDataItem?.Segments?.map((x) => {
        return {
          _id: x?._id,
          Description: x?.Description
        }
      }) : []
    }

    if (assetDataItem._id != undefined) {
      saveData._id = assetDataItem._id;
      saveData.SID = assetDataItem.SID
    }

    console.log(saveData);

    let res = await API.saveData(ENTITYNAME.OttAsset, saveData);

    let logData = { event: res.message == "inserted" ? LOGEVENT.CREATE_ASSETS : LOGEVENT.UPDATE_ASSETS, module: MODULE.OTT_ASSETS, data: res.data, message: res.message };
    API.SaveLogs(logData);
    return res;
  };

  const onCancel = () => {

    if (seriesEntity.SID == 0) {

      ConfirmAlert(() => {
        if (location.state && location.state.prevPath) {
          navigate(location.state.prevPath)
        } else {
          navigate(-1) ? navigate(-1) : window.close();
        }
      }, () => { return; }, "Discard changes?", "Are you sure you want to discard changes?")
    } else {
      if (location.state && location.state.prevPath) {
        let state = {
          ...location.state,
          // pagination: location.state.pagination ?? "",
          paths: location.state.paths.slice(0, -1)
        }
        navigate((location.state.paths.length == 0 ? location.state.prevPath : location.state.paths.pop()), { state: state })
      } else {
        navigate(-1) ? navigate(-1) : window.close();
      }
    }
  }

  //ON BOSS ASSISTANT ICON CLICK
  const onBossAIMetaDataLoad = async (item) => {

    let aiDataRes = await utility.loadDataViaBOSS_AI(BA_ACTION.FullMetaData, item, mediaEpisodeEntity);
    console.log(aiDataRes);
    return aiDataRes;

  }

  //FUNCTION FOR FETCHING META DATAFROM BOSS AI
  const setMetaData = (data) => {

    let newMetaData = {
      Title: data.Title,
      Description: data.Description,
      Synopsis: data.Synopsis && data.Synopsis.length > 0 ? data.Synopsis[0].Synopsis : "",
      Genres: genres.filter((x) => x.Description.toLowerCase() == data.Genre.toLowerCase()),
      SubGenres: genres.filter((x) => x.Description.toLowerCase() == data.SubGenre.toLowerCase()),
      ProductionYear: data.ProductionYear ?? '',
      Languages: data.Languages && data.Languages.length > 0 ?
        data.Languages.map((item) => { return languages.find((x) => x.Description && x.Description.toLowerCase() == item.toLowerCase()) }) : [],
      Keywords: data.Keywords ?? '',
      PGRating: pgRatings.find((x) => x.Description == data.PGRating) ? pgRatings.find((x) => x.Description == data.PGRating) : {},
      Categories: data?.Categories && data?.Categories?.length > 0 ? data?.Categories?.map((item) => {
        return {
          _id: item?._id,
          Name: item?.Name,
          parent: item?.parent
        }
      }) : [],
      Extension: data?.Extension ?? {},
      dynamicField: data?.dynamicField ?? {},
      DubbedLanguages: data.DubbedLanguages && data.DubbedLanguages.length > 0 ?
        data.DubbedLanguages.map((item) => { return languages.find((x) => x.Description && x.Description.toLowerCase() == item.toLowerCase()) }) : []
    }
    setSeriesEntity({ ...seriesEntity, ...newMetaData });
    setMediaEpisodeEntity({ ...seriesEntity, ...newMetaData });
  }

  const onSelectSeason = async (seasonData) => {
    if (seasonData?.length == 0) return;

    const updatedSeasons = seasonData.map(season => ({
      ...season,
      Series_Id: seriesEntity._id
    }));

    const res = await API.bulkUpdate(ENTITYNAME.Season, updatedSeasons);
    console.log(res);
    if (res.success) {
      loadEditData();
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.season_attached_success_message });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.unable_to_attach_season_error_message });
    };
  }

  return (
    <>
      <div className="myFlexContainer" >
        <FixedSidebarWithIcons menuModel={sideFixMenu} />
        {openSeason && <CardList
          MenuModal={getSeriesMenu}
          close={() => setOpenSeason(false)}
          containerName="Destination"
          customeModelFields={customeModelFields}
          title={lang.series_cardlist_header}
          onAddClick={() => navigate("/home/MediaEpisode/Season/0", { state: { quickEdit: false, selectedSeries: seriesEntity, disableSelectSeries: true, existingSeason: season } })}
          posterURL="https://play-lh.googleusercontent.com/LsmwRk16eEuZXxYLc-FGARu72Ji1qQq3Ow5d0aQ6tX2JE_yAFwRVx0Ubuv5rWuhNnSEa=w480-h960-rw"
          cardData={season}
          showSearch={true}
          onEditDataItem={onSeasonEdit}
          onDeleteDataItem={deleteSeason}
          inTileView={false}
          showTileView={true}
          showPreferenceButton={true}
          columnEntityName={'season'}
          isWide={true}
          onLinkClick={() => setShowSeasonCollection(true)}
          shortBy="SeasonNumber"
          source={{ entityName: ENTITYNAME.Series, _id: seriesEntity?._id }}
        />}
        <div className="main-layout" >
          <EditPageHeader title={`${lang.series_sub_menu} -> ` + (seriesEntity.Title ? seriesEntity.Title : `${lang.new_button_dialog_header}`)} onSubmit={onSave} onCancel={onCancel} isLoading={isSaving} />
          <SeriesDetailForm
            dataItem={seriesEntity}
            setDataItem={setSeriesEntity}
            setSeriesData={handleSetSeriesEntity}
            quickEdit={location?.state?.quickEdit ?? false}
            setIsArchiveChanged={setIsArchiveChanged}
            isArchiveChanged={isArchiveChanged}
            createSeasonEpisode={createSeasonEpisode}
            setCreateSeasonEpisode={setCreateSeasonEpisode}
            onSave={onSave}
            isFromAddProgram={location?.state?.isFromAddProgram ?? false}
            isManualAssetId={isManualAssetId}
            setIsManualAssetId={setIsManualAssetId}
          />
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={tabNumber}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <TabList onChange={handleTabChange} variant="scrollable" scrollButtons="auto" aria-label="lab API tabs example">
                    <Tab label={lang.meta_data_label} value="1" />
                    <Tab label={lang.publishing_label} value="2" />
                    <Tab label={lang.ott_assets_collection_header} value="3" />
                    <Tab label={lang.transmission_label} value="4" />
                  </TabList>
                  <BossAssistantIcon
                    style={{}}
                    mediaEpisodeEntity={seriesEntity}
                    onDataLoad={onBossAIMetaDataLoad}
                    tooltip={"Generate full meta data with Boss AI"}
                    description={"BOSS AI Generating Meta Data"}
                    setMetaData={setMetaData}
                  />
                </Box>
              </Box>
              <TabPanel value="1">
                {isLoadedEdit && <SeasonMetaDataEditForm dataItem={seriesEntity} setMataData={setMataData} />}
              </TabPanel>
              <TabPanel value="2">
                <div className="row">
                  <MediaEpisodePublishingEditForm
                    mediaCategory={mediaCategory.find((obj) => obj.SID == MEDIACATEGORIES.Series)}
                    mediaEpisodeEntity={mediaEpisodeEntity}
                    publishingSource={PUBLISHING_SOURCE.Series}
                    openPublishingDialog={openPublishingDialog}
                    setOpenPublishingDialog={setOpenPublishingDialog}
                    isNewMedia={!isEdit}
                  />
                </div>
              </TabPanel>
              <TabPanel value="3">
                <div className="row mb-4" style={{ scrollbarWidth: "none", msOverflowStyle: 'none', overflow: 'auto', height: '63vh', boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: "13px 0px 15px 5px" }}>
                  <MediaEpisodeAssetEditForm source={'series'} sourceEntity={seriesEntity} entityname={ENTITYNAME.OttAsset} dataItem={assetDataItem} setDataEntity={setAssetEntity} setPotraitImageFiles={setPotraitImageFiles} setLandscapeImageFiles={setLandscapeImageFiles} selectedLanguage={company.Language} />
                </div>
              </TabPanel>
              <TabPanel value="4">
                <div className="row">
                  <TransmissionBrowser isFromMedia={true} selectedNode={mediaEpisodeEntity} showToggle={true} query={["series_id", "=", mediaEpisodeEntity?._id]} mainStyle={{ height: 'calc(100vh - 300px)' }} gridStyle={{ height: 'calc(100vh - 520px)' }} entityName={ENTITYNAME.Series} />
                </div>
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      </div>
      {showSeasonCollection && <CollectionSelection entityname={ENTITYNAME.Season} closeForm={() => setShowSeasonCollection(false)} setDataList={onSelectSeason} wherestatement={[['Series_Id', '=', null], ["Archive", "!=", true]]} title={lang.select_season_label} mode={"multiple"} width={"50vw"} />}
    </>)
};